export const SET_TOGGLED_MONTHS = 'SET_TOGGLED_MONTHS';
export const TOGGLE_MONTH = 'TOGGLE_MONTH';
export const TOGGLE_MONTH_SESSIONS = 'TOGGLE_MONTH_SESSIONS';
export const TOGGLE_SOLD_OUT_SESSIONS = 'TOGGLE_SOLD_OUT_SESSIONS';
